import type { ZodType } from "@core/zod";
import { z } from "@core/zod";

interface SerialId<Prefix extends string> {
  readonly first: `${Prefix}${number}`;
  readonly idSchema: ZodType<`${Prefix}${number}`, `${Prefix}${number}`>;
  readonly next: (id: `${Prefix}${number}`) => `${Prefix}${number}`;
}

export function createSerialId<Prefix extends string>(
  prefix: Prefix,
): SerialId<Prefix> {
  const schema = z
    .safeId()
    .refine(
      value =>
        value.startsWith(prefix) && /^\d+$/u.test(value.slice(prefix.length)),
      `Must be ${prefix} followed by a number`,
    );

  return {
    first: `${prefix}1`,
    // oxlint-disable-next-line @typescript-eslint/consistent-type-assertions
    idSchema: schema as ZodType<`${Prefix}${number}`, `${Prefix}${number}`>,
    next: id => `${prefix}${Number(id.slice(prefix.length)) + 1}`,
  };
}
